<template>
  <div>
    <v-card>
      <v-card-title>
        <v-text-field v-model="search" label="Schnellsuche" single-line></v-text-field>
      </v-card-title>
      <v-data-table
        :headers="computedHeaders"
        :items="tickets"
        :footer-props="{'items-per-page-options':[15, 30, 50, 100, -1]}"
        :options="pagination"
        item-key="id"
        dense
        class="elevation-1"
        :single-expand="true"
        :expanded.sync="expanded"
        show-expand
        :search="search"
        hide-sort
        @click:row="clicked"
      >
        <template v-slot:expanded-item="t">
          <td :colspan="headers.length + 1" class="detailInfo">
            <TicketDetailInfo v-bind:ticket="t.item" />
          </td>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
// import TicketInfo from "./TicketInfo.vue";
import TicketDetailInfo from "./TicketDetailInfo.vue";

export default {
  name: "Tickets",
  components: {
    //TicketInfo,
    TicketDetailInfo
  },
  props: ["tickets"],
  data() {
    return {
      pagination: {
        itemsPerPage: 100
      },
      search: "",
      expanded: [],
      expandedTicketId: "",
      headers: [
        { text: "Gültig vom", value: "validity" },
        { text: "Gültig bis", value: "validtill" },
        { text: "Kennzeichen", value: "licenceplate" },
        { text: "Name", value: "fullname" }
      ]
    };
  },
  computed: {
    computedHeaders() {
      return this.headers.filter(h => !h.hide);
    }
  },
  methods: {
    async clicked(value) {
      await this.expanded.pop();
      this.expanded.push(value);
    }
  },
  filters: {
    toDate(value) {
      let date = new Date(value);
      return date
        .toDateString()
        .split(" ")
        .slice(1)
        .join(". ");
    }
  }
};
</script>

<style scoped>
.detailInfo {
  background-color: rgba(0, 2, 3, 0.2);
}
</style>